var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTriangleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09284 6H0.961708C0.556929 6 0.319914 5.54412 0.55243 5.21279L3.77934 0.614441C3.98439 0.322251 4.42075 0.332854 4.61136 0.634658L7.51558 5.233C7.72586 5.56594 7.48661 6 7.09284 6Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTriangleUp);
export default __webpack_public_path__ + "static/media/arrow-triangle-up.0fbe3fbaa479c707826166fd35cba607.svg";
export { ForwardRef as ReactComponent };